import developerService from "./developer.service";

export async function loadOrCreateDeveloperProfile(user) {
  try {
    const profile = await developerService.getProfile();
    if (profile) {
      return profile;
    }
  } catch (_) {
    // Fall through to onboarding.
  }

  const onboarded = await developerService.onboard({
    name: user.displayName || "",
    email: user.email || "",
    company: null,
  });

  try {
    const profile = await developerService.getProfile();
    if (profile) {
      return {
        ...profile,
        apiKey: onboarded?.apiKey || profile.apiKey || null,
      };
    }
  } catch (_) {
    // Use onboard response as a fallback if the follow-up profile request fails.
  }

  return onboarded;
}

export async function regenerateDeveloperKey() {
  const { apiKey } = await developerService.regenerateKey();
  return apiKey;
}

export async function markOnboardingComplete() {
  return developerService.updateProfile({ onboardingComplete: true });
}
